// extracted by mini-css-extract-plugin
export default {"layout":"layout__fe24c635","no_padding":"no_padding__fe24c635","footer":"footer__fe24c635"};